(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningPathAssign", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/assignments/path/learningPathAssignView.html",
            controller: ["assignmentMapsResource", "messageService", "webJobService", "$scope", "$sessionStorage", "$state", "_", "$timeout", LearningPathAssignCtrl],
            controllerAs: "vm"
        };
        function LearningPathAssignCtrl(assignmentMapsResource, messageService, webJobService, $scope, $sessionStorage, $state, _, $timeout) {
            var vm = this;
            vm.language = "";
            vm.isGroupAssign = $state.current.name.indexOf("pathsToGroupsAdd") > 1;
            //Variables that are used to save selection through steps
            vm.learningPaths = [];
            vm.groups = [];
            vm.learners = [];
            //Variables to form binding model for save
            vm.selectedLearningPaths = [];
            vm.selectedGroups = [];
            vm.groupFormData = { paths: {}, groups: {} };
            //Validation variables
            vm.stepIsValid = false;
            vm.loadedStep1 = false;
            vm.loadedStep2 = false;
            //Select all check box
            vm.isCheckAllPath = false;
            vm.isCheckAllGroup = false;
            vm.areAllLearnersChecked = false;
            vm.confirmButtonEnabled = true;
            vm.step = 1;
            vm.nextButtonText = "common.next";
            vm.showErrors = false;
            //prevents changing the URL to access the other steps
            $timeout(function () {
                if ($state.current.name.indexOf("step" + vm.step) === -1) {
                    if (vm.isGroupAssign)
                        $state.go("main.assignments.pathsToGroupsAdd.step" + vm.step);
                    else
                        $state.go("main.assignments.pathsToLearnersAdd.step" + vm.step);
                }
            });
            vm.save = function () {
                if (!vm.confirmButtonEnabled)
                    return;
                vm.confirmButtonEnabled = false;
                if (vm.isGroupAssign) {
                    vm.groupFormData.paths = vm.selectedLearningPaths;
                    vm.groupFormData.groups = vm.selectedGroups;
                    assignmentMapsResource.assignPathToGroup(vm.groupFormData, function (result) {
                        if (result.value) {
                            //webJobService.processAssignmentMapQueue();
                            vm.goToStep(4);
                            vm.clearSessionData();
                        }
                        else {
                            vm.confirmButtonEnabled = true;
                            messageService.error("common.genericError");
                        }
                    }, function () {
                        vm.confirmButtonEnabled = true;
                        messageService.error("common.genericError");
                    });
                }
                else {
                    assignmentMapsResource.assignPathToLearners({ paths: vm.selectedLearningPaths, learners: vm.selectedLearners }, function () {
                        webJobService.processAssignmentMapQueue();
                        vm.goToStep(4);
                        vm.clearSessionData();
                    }, function () {
                        vm.confirmButtonEnabled = true;
                        messageService.error("common.genericError");
                    });
                }
            };
            vm.clearSessionData = function () {
                vm.dtPathInstance.DataTable.state.clear();
                if (vm.isGroupAssign) {
                    vm.dtGroupInstance.DataTable.state.clear();
                    $sessionStorage.assignLearningPathsToGroupsFilters.search = "";
                    $sessionStorage.assignGroupFilters.search = "";
                }
                else {
                    $sessionStorage.assignLearningPathsToLearnersFilters.search = "";
                    $sessionStorage.assignLearnersFilters2.firstName.value = "";
                    $sessionStorage.assignLearnersFilters2.lastName.value = "";
                    $sessionStorage.assignLearnersFilters2.groups.value = "";
                }
            };
            vm.clearSessionStorage = function () {
                if (vm.dtPathInstance)
                    vm.dtPathInstance.DataTable.state.clear();
                if ($sessionStorage.assignLearningPathsToGroupsFilters)
                    $sessionStorage.assignLearningPathsToGroupsFilters.search = "";
                if ($sessionStorage.assignLearningPathsToLearnersFilters)
                    $sessionStorage.assignLearningPathsToLearnersFilters.search = "";
            };
            vm.goToStep = function (step) {
                if (vm.stepIsValid || step < vm.step) {
                    vm.showErrors = false;
                    if (vm.step === 1) {
                        vm.loadedStep1 = true;
                    }
                    if (vm.step === 2) {
                        vm.loadedStep2 = true;
                    }
                    vm.step = step;
                    if (vm.step === 3) {
                        vm.nextButtonText = "common.confirm";
                        vm.selectedLearningPaths = _.where(vm.learningPaths, { checked: true });
                        vm.selectedGroups = _.where(vm.groups, { checked: true });
                        vm.selectedLearners = _.map(_.where(vm.learners, { status: true }), function (item) { return item.item; });
                    }
                    else
                        vm.nextButtonText = "common.next";
                    if (vm.isGroupAssign)
                        $state.go("main.assignments.pathsToGroupsAdd.step" + vm.step);
                    else
                        $state.go("main.assignments.pathsToLearnersAdd.step" + vm.step);
                }
                else {
                    vm.showErrors = true;
                }
            };
            //vm.clearSessionStorage();
        }
    });
}());
